// extracted by mini-css-extract-plugin
export var form = "_eg-0";